import { DecimalPipe } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CurrentCartItemPrice } from 'app/features/cart';
import { OrderItem } from 'app/features/order/models/order-item';
import { QuoteItem } from 'app/features/quote/models/quote-item';

@Injectable({
  providedIn: 'root',
})
export class PricesService {
  constructor(@Inject(LOCALE_ID) private localeId: string) {}

  public summarizePrices(items: CurrentCartItemPrice[] | OrderItem[] | QuoteItem[]): string {
    // ignore alternative prices
    if (items.some((i) => i.TypeId === 'A')) {
      items = (items as QuoteItem[]).filter((t) => t.TypeId !== 'A');
    }

    // sum all prices
    const sum = items.map((c) => c.NetPriceTotal).reduce((a, b) => a + b, 0);

    // make localized decimal pipe
    const totalPrice = new DecimalPipe(this.localeId).transform(sum, '1.2-2');

    // look for currency
    const currency = items && items.length > 0 ? items[0].NetPriceCurrency : '';

    return `${totalPrice} ${currency ? currency : ''}`;
  }
}
